export default {
  promo: {
    it: "Promo",
    en: "Promo",
  },
  deal: {
    it: "Sconto",
    en: "Deal",
  },
  cashback: {
    it: "Cashback",
    en: "Cashback",
  },
  new: {
    it: "Novità",
    en: "New",
  },
};
